import { render } from "./personality-profile.vue?vue&type=template&id=358f0b18&scoped=true"
import script from "./personality-profile.vue?vue&type=script&lang=js"
export * from "./personality-profile.vue?vue&type=script&lang=js"

import "./personality-profile.vue?vue&type=style&index=0&id=358f0b18&lang=scss&scoped=true"

import exportComponent from "/builds/grxl/cinematech/jmpt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-358f0b18"]])

export default __exports__